export const SLICE_BILAN_BLOC = "bilan_bloc";
export const SLICE_THREE_REASONS_CONSULYTATION = "three_reasons_consultation";
export const SLICE_FIXED_BOTTOM_BAR = "fixed_bottom_bar";
